var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field is-expanded"},[_c('model-select',{staticClass:"input",attrs:{"options":_vm.options,"placeholder":"Select Client"},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe1c44ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceClientSelect.vue
// module id = null
// module chunks = 